import React from "react";

interface UltrasoundProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

const Ultrasound: React.FC<UltrasoundProps> = ({
  width = 20,
  height = 16,
  fillColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.63636 8.502L6.63636 13.6569C6.63636 14.4333 7.24688 15.0627 8 15.0627C8.75312 15.0627 9.36364 14.4333 9.36364 13.6569L9.36364 8.502H10.2727C11.2769 8.502 12.0909 7.66276 12.0909 6.6275V5.17767C12.0909 4.53514 11.79 4.09 11.3947 3.93968C10.6286 3.6484 9.47946 3.34713 8 3.34713C6.52054 3.34713 5.37136 3.6484 4.60532 3.93968C4.21001 4.09 3.90909 4.53514 3.90909 5.17767V6.6275C3.90909 7.66276 4.72312 8.502 5.72727 8.502H6.63636ZM5.72727 9.43925C4.22104 9.43925 3 8.18039 3 6.6275V5.17767C3 4.25177 3.44814 3.38073 4.29074 3.06034C5.14334 2.73614 6.39906 2.40988 8 2.40988C9.60094 2.40988 10.8567 2.73614 11.7093 3.06034C12.5519 3.38073 13 4.25177 13 5.17767V6.6275C13 8.18039 11.779 9.43925 10.2727 9.43925L10.2727 13.6569C10.2727 14.9509 9.25519 16 8 16C6.74481 16 5.72727 14.9509 5.72727 13.6569L5.72727 9.43925Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.63636 8.502L6.63636 13.6569C6.63636 14.4333 7.24688 15.0627 8 15.0627C8.75312 15.0627 9.36364 14.4333 9.36364 13.6569L9.36364 8.502H10.2727C11.2769 8.502 12.0909 7.66276 12.0909 6.6275V5.17767C12.0909 4.53514 11.79 4.09 11.3947 3.93968C10.6286 3.6484 9.47946 3.34713 8 3.34713C6.52054 3.34713 5.37136 3.6484 4.60532 3.93968C4.21001 4.09 3.90909 4.53514 3.90909 5.17767V6.6275C3.90909 7.66276 4.72312 8.502 5.72727 8.502H6.63636ZM5.72727 9.43925C4.22104 9.43925 3 8.18039 3 6.6275V5.17767C3 4.25177 3.44814 3.38073 4.29074 3.06034C5.14334 2.73614 6.39906 2.40988 8 2.40988C9.60094 2.40988 10.8567 2.73614 11.7093 3.06034C12.5519 3.38073 13 4.25177 13 5.17767V6.6275C13 8.18039 11.779 9.43925 10.2727 9.43925L10.2727 13.6569C10.2727 14.9509 9.25519 16 8 16C6.74481 16 5.72727 14.9509 5.72727 13.6569L5.72727 9.43925Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.63636 8.502L6.63636 13.6569C6.63636 14.4333 7.24688 15.0627 8 15.0627C8.75312 15.0627 9.36364 14.4333 9.36364 13.6569L9.36364 8.502H10.2727C11.2769 8.502 12.0909 7.66276 12.0909 6.6275V5.17767C12.0909 4.53514 11.79 4.09 11.3947 3.93968C10.6286 3.6484 9.47946 3.34713 8 3.34713C6.52054 3.34713 5.37136 3.6484 4.60532 3.93968C4.21001 4.09 3.90909 4.53514 3.90909 5.17767V6.6275C3.90909 7.66276 4.72312 8.502 5.72727 8.502H6.63636ZM5.72727 9.43925C4.22104 9.43925 3 8.18039 3 6.6275V5.17767C3 4.25177 3.44814 3.38073 4.29074 3.06034C5.14334 2.73614 6.39906 2.40988 8 2.40988C9.60094 2.40988 10.8567 2.73614 11.7093 3.06034C12.5519 3.38073 13 4.25177 13 5.17767V6.6275C13 8.18039 11.779 9.43925 10.2727 9.43925L10.2727 13.6569C10.2727 14.9509 9.25519 16 8 16C6.74481 16 5.72727 14.9509 5.72727 13.6569L5.72727 9.43925Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.63636 8.502L6.63636 13.6569C6.63636 14.4333 7.24688 15.0627 8 15.0627C8.75312 15.0627 9.36364 14.4333 9.36364 13.6569L9.36364 8.502H10.2727C11.2769 8.502 12.0909 7.66276 12.0909 6.6275V5.17767C12.0909 4.53514 11.79 4.09 11.3947 3.93968C10.6286 3.6484 9.47946 3.34713 8 3.34713C6.52054 3.34713 5.37136 3.6484 4.60532 3.93968C4.21001 4.09 3.90909 4.53514 3.90909 5.17767V6.6275C3.90909 7.66276 4.72312 8.502 5.72727 8.502H6.63636ZM5.72727 9.43925C4.22104 9.43925 3 8.18039 3 6.6275V5.17767C3 4.25177 3.44814 3.38073 4.29074 3.06034C5.14334 2.73614 6.39906 2.40988 8 2.40988C9.60094 2.40988 10.8567 2.73614 11.7093 3.06034C12.5519 3.38073 13 4.25177 13 5.17767V6.6275C13 8.18039 11.779 9.43925 10.2727 9.43925L10.2727 13.6569C10.2727 14.9509 9.25519 16 8 16C6.74481 16 5.72727 14.9509 5.72727 13.6569L5.72727 9.43925Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0181 5.66006C7.41188 5.63712 6.77801 5.75757 5.89774 6.12469C5.66502 6.22175 5.40005 6.10593 5.30591 5.866C5.21177 5.62608 5.32411 5.3529 5.55682 5.25584C6.51977 4.85424 7.28337 4.69437 8.05145 4.72344C8.80608 4.75201 9.53445 4.96309 10.4076 5.24274C10.6473 5.31952 10.7813 5.58213 10.7068 5.8293C10.6323 6.07646 10.3776 6.21458 10.1379 6.13779C9.26052 5.85679 8.63777 5.68352 8.0181 5.66006Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0181 5.66006C7.41188 5.63712 6.77801 5.75757 5.89774 6.12469C5.66502 6.22175 5.40005 6.10593 5.30591 5.866C5.21177 5.62608 5.32411 5.3529 5.55682 5.25584C6.51977 4.85424 7.28337 4.69437 8.05145 4.72344C8.80608 4.75201 9.53445 4.96309 10.4076 5.24274C10.6473 5.31952 10.7813 5.58213 10.7068 5.8293C10.6323 6.07646 10.3776 6.21458 10.1379 6.13779C9.26052 5.85679 8.63777 5.68352 8.0181 5.66006Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0181 5.66006C7.41188 5.63712 6.77801 5.75757 5.89774 6.12469C5.66502 6.22175 5.40005 6.10593 5.30591 5.866C5.21177 5.62608 5.32411 5.3529 5.55682 5.25584C6.51977 4.85424 7.28337 4.69437 8.05145 4.72344C8.80608 4.75201 9.53445 4.96309 10.4076 5.24274C10.6473 5.31952 10.7813 5.58213 10.7068 5.8293C10.6323 6.07646 10.3776 6.21458 10.1379 6.13779C9.26052 5.85679 8.63777 5.68352 8.0181 5.66006Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0181 5.66006C7.41188 5.63712 6.77801 5.75757 5.89774 6.12469C5.66502 6.22175 5.40005 6.10593 5.30591 5.866C5.21177 5.62608 5.32411 5.3529 5.55682 5.25584C6.51977 4.85424 7.28337 4.69437 8.05145 4.72344C8.80608 4.75201 9.53445 4.96309 10.4076 5.24274C10.6473 5.31952 10.7813 5.58213 10.7068 5.8293C10.6323 6.07646 10.3776 6.21458 10.1379 6.13779C9.26052 5.85679 8.63777 5.68352 8.0181 5.66006Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.98233 0.937322C7.07105 0.933301 6.15221 1.09605 4.94383 1.45437C4.70257 1.52591 4.45074 1.38227 4.38135 1.13354C4.31196 0.88481 4.45129 0.625179 4.69255 0.553639C5.94883 0.181113 6.9585 -0.00445317 7.98622 8.11196e-05C9.01199 0.00460678 10.0298 0.198482 11.3001 0.551532C11.5425 0.618895 11.686 0.876083 11.6207 1.12598C11.5554 1.37587 11.3059 1.52384 11.0635 1.45648C9.82725 1.1129 8.89556 0.941351 7.98233 0.937322Z"
        fill={fillColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.98233 0.937322C7.07105 0.933301 6.15221 1.09605 4.94383 1.45437C4.70257 1.52591 4.45074 1.38227 4.38135 1.13354C4.31196 0.88481 4.45129 0.625179 4.69255 0.553639C5.94883 0.181113 6.9585 -0.00445317 7.98622 8.11196e-05C9.01199 0.00460678 10.0298 0.198482 11.3001 0.551532C11.5425 0.618895 11.686 0.876083 11.6207 1.12598C11.5554 1.37587 11.3059 1.52384 11.0635 1.45648C9.82725 1.1129 8.89556 0.941351 7.98233 0.937322Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.98233 0.937322C7.07105 0.933301 6.15221 1.09605 4.94383 1.45437C4.70257 1.52591 4.45074 1.38227 4.38135 1.13354C4.31196 0.88481 4.45129 0.625179 4.69255 0.553639C5.94883 0.181113 6.9585 -0.00445317 7.98622 8.11196e-05C9.01199 0.00460678 10.0298 0.198482 11.3001 0.551532C11.5425 0.618895 11.686 0.876083 11.6207 1.12598C11.5554 1.37587 11.3059 1.52384 11.0635 1.45648C9.82725 1.1129 8.89556 0.941351 7.98233 0.937322Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.98233 0.937322C7.07105 0.933301 6.15221 1.09605 4.94383 1.45437C4.70257 1.52591 4.45074 1.38227 4.38135 1.13354C4.31196 0.88481 4.45129 0.625179 4.69255 0.553639C5.94883 0.181113 6.9585 -0.00445317 7.98622 8.11196e-05C9.01199 0.00460678 10.0298 0.198482 11.3001 0.551532C11.5425 0.618895 11.686 0.876083 11.6207 1.12598C11.5554 1.37587 11.3059 1.52384 11.0635 1.45648C9.82725 1.1129 8.89556 0.941351 7.98233 0.937322Z"
        fill={fillColor}
        fill-opacity="0.2"
      />
    </svg>
  );
};

export default Ultrasound;

